export const messageRecipientDetailFrag = `
    id
    readAt
    message {
        id
        title
        content
        type
        category
        validFrom
        validTo
        createdAt
        files {
            id
            name
            path
        }
    }
`;
